module.exports = __webpack_public_path__ + "static/uks-case-study-65342660e52af02a51c1cf7d75599eec.webp";